//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[[["displayPart"],"CreateJoinValidator",{R_:{validator:"JoinBaseValidator"}},1,0],[["mainValidator","selectedModules","pointJoinSubtypeToggle","curveJoinSubtypeToggle","joinParmsToggle","numValidators","validators","joinsPresent"],"PopulateValidators",{},5,0]],[]];
SPLM.JoinDebugSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.JoinDebugSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;